// app/javascript/controllers/account_user_profile_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subButton", "location", "phone", "profileRoles", "roleCheckbox", "inviteButton"];

  static values = {
    inviteUrl: String 
  }

  connect() {
    console.log('connected account user profile', {test: this.inviteUrlValue })
    this.element.addEventListener("submit", (event) => {
      this.disableButton()
    })
 
    this.updateProfile(); // Initial update in case there are default values
    this.updateProfileRoles(); // Initial update for roles
  }


  disableButton() {
    console.log('submitted')
    this.subButtonTarget.disabled = true

    console.log("here",this.subButtonTarget)
    this.subButtonTarget.innerHTML = `
      <i class="fa-solid fa-spinner fa-spin mr-2"></i>
      Saving...
    `
  }  

  async sendInvite(event) {
    event.preventDefault()
    if (!confirm("Send signup invitation email?")) return
  
    try {
      this.inviteButtonTarget.innerHTML = `
        <i class="fa-solid fa-spinner fa-spin mr-2"></i>
        Sending...
      `
      this.inviteButtonTarget.disabled = true
  
      const response = await fetch(this.inviteUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
          "Accept": "text/vnd.turbo-stream.html"
        },
        credentials: 'include' 
      })
        console.log({response}, response.body)
        const html = await response.text();
       // window.location.reload()
        console.log("hmtl", {html})
        Turbo.renderStreamMessage(html);

 
     
    } catch (error) {
      console.log('ailed here', error)
      alert(error.message)
    } finally {
      this.inviteButtonTarget.disabled = false
      this.inviteButtonTarget.innerHTML = `Send Signup Invite`
    }
  }

  

  capitalizeWords(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }


  formatPhoneNumber(number) {
    // Remove non-digit characters
    number = number.replace(/\D/g, "");

    if (number.length === 10) {
      return `(${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6)}`;
    } else if (number.length === 11 && number.startsWith('1')) {
      return `+1 (${number.substring(1, 4)}) ${number.substring(4, 7)}-${number.substring(7)}`;
    } else {
      return number; // Return unformatted if not 10 or 11 digits
    }
  }

  updateProfile() {

    const city = this.capitalizeWords(this.element.querySelector("#city_input").value || "City");
    const state = this.capitalizeWords(this.element.querySelector("#state_input").value || "State");
    const phone = this.element.querySelector("#phone_input").value;
    const formattedPhone = this.formatPhoneNumber(phone) || "Phone"; // Format the phone number


    const locations = `${city}, ${state}`;

    this.locationTarget.textContent = locations;
    this.phoneTarget.textContent = formattedPhone;

  }

  updateProfileRoles() {
    const activeRoles = [];
    this.roleCheckboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        activeRoles.push(checkbox.dataset.roleName);
      }
    });
    this.profileRolesTarget.textContent = activeRoles.slice(0, 3).join(', ');
  }

  toggleRole() {
    this.updateProfileRoles();
  }
}
